(function () {
  var DEBUG = true;
  var log = function () {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[Shop by Artist]');
    console.log.apply(console, args);
  };

  var root = document.querySelector('[data-shop-by-artist]');

  if (!root) {
    return;
  }

  var cfgEl = root.querySelector('[data-shop-by-artist-config]');

  if (!cfgEl) {
    log('Config element not found');
    return;
  }

  var config;
  try {
    config = JSON.parse(cfgEl.textContent);
  } catch (e) {
    log('Failed to parse config JSON', e);
    return;
  }

  var collectionHandle = config.collectionHandle;
  var artistProductMap = config.artistProductMap || [];
  var metaobjectStockArtists = config.metaobjectStockArtists || [];
  var metaobjectProductMap = config.metaobjectProductMap || [];
  var artistsConfig = config.artists || [];

  if (!collectionHandle) {
    log('No collection handle — exiting');
    return;
  }

  log('Initialized', {
    collection: collectionHandle,
    artistsTotal: artistsConfig.length,
    collectionProductMappings: artistProductMap.length,
    metaobjectProductMappings: metaobjectProductMap.length,
    metaobjectStockArtists: metaobjectStockArtists.length
  });

  function applyStockState(item, hasStock) {
    var link = item.querySelector('.artist-link');
    var label = link ? link.querySelector('p') : null;

    if (hasStock) {
      item.classList.add('has-stock');
      item.classList.remove('no-stock');
      if (link) {
        link.classList.remove('opacity-50');
        link.style.opacity = '';
        link.style.pointerEvents = '';
      }
      if (label) {
        label.classList.add('fw-bold');
        label.classList.remove('fw-light');
      }
      return;
    }

    item.classList.add('no-stock');
    item.classList.remove('has-stock');
    if (link) {
      link.classList.add('opacity-50');
      link.style.opacity = '0.5';
      link.style.pointerEvents = 'none';
    }
    if (label) {
      label.classList.add('fw-light');
      label.classList.remove('fw-bold');
    }
  }

  var routesRoot = '/';
  if (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) {
    routesRoot = window.Shopify.routes.root;
  }
  if (routesRoot.charAt(routesRoot.length - 1) !== '/') {
    routesRoot += '/';
  }

  function parseLinkNext(linkHeader) {
    if (!linkHeader || typeof linkHeader !== 'string') return null;
    var parts = linkHeader.split(',');
    for (var i = 0; i < parts.length; i++) {
      var segment = parts[i].trim();
      if (!/rel=["']?next["']?/i.test(segment)) continue;
      var m = segment.match(/<([^>]+)>/);
      if (m) return m[1];
    }
    return null;
  }

  function resolveUrl(href) {
    if (!href) return null;
    if (href.indexOf('http') === 0) return href;
    if (href.indexOf('//') === 0) return window.location.protocol + href;
    var path = href.charAt(0) === '/' ? href : '/' + href;
    return window.location.origin + path;
  }

  function fetchAllProducts() {
    var out = [];
    var seen = {};
    var limit = 250;
    var pagesLoaded = 0;
    var maxRequests = 250;
    var requestCount = 0;

    var nextUrl =
      routesRoot +
      'collections/' +
      encodeURIComponent(collectionHandle) +
      '/products.json?limit=' +
      limit;

    function done() {
      return { products: out, pagesLoaded: pagesLoaded };
    }

    function next() {
      if (requestCount >= maxRequests) return Promise.resolve(done());
      requestCount += 1;
      return fetch(nextUrl, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) return null;
          var linkHeader = res.headers.get('Link');
          return res.json().then(function (data) {
            return { data: data, linkHeader: linkHeader };
          });
        })
        .then(function (wrapped) {
          if (!wrapped || !wrapped.data) return done();
          var products = wrapped.data.products || [];
          if (!products.length) return done();
          pagesLoaded += 1;
          var added = 0;
          for (var i = 0; i < products.length; i++) {
            var p = products[i];
            var id = String(p.id);
            if (seen[id]) continue;
            seen[id] = true;
            out.push(p);
            added++;
          }
          if (added === 0) return done();

          var linkNext = parseLinkNext(wrapped.linkHeader);
          if (linkNext) {
            nextUrl = resolveUrl(linkNext);
            return next();
          }
          if (products.length < limit) return done();
          var lastId = products[products.length - 1].id;
          nextUrl =
            routesRoot +
            'collections/' +
            encodeURIComponent(collectionHandle) +
            '/products.json?limit=' +
            limit +
            '&since_id=' +
            lastId;
          return next();
        })
        .catch(function (err) {
          log('Collection fetch error', err);
          return done();
        });
    }

    return next();
  }

  function productIsAvailable(product) {
    if (!product) return false;
    if (product.available === true) return true;
    if (product.available === false) return false;
    var variants = product.variants || [];
    for (var v = 0; v < variants.length; v++) {
      if (variants[v].available) return true;
    }
    return false;
  }

  function getStockReason(collectionHasStock, metaobjectHasStock) {
    if (collectionHasStock && metaobjectHasStock) return 'collection + metaobject';
    if (collectionHasStock) return 'collection';
    if (metaobjectHasStock) return 'metaobject';
    return 'none';
  }

  var artistStockFromLiquid = {};

  for (var i = 0; i < artistProductMap.length; i++) {
    var mapping = artistProductMap[i];
    var artist = mapping.artist;
    var isAvailable = mapping.available === true || mapping.available === 'true';

    if (!artistStockFromLiquid[artist]) {
      artistStockFromLiquid[artist] = {
        hasStock: false,
        totalProducts: 0,
        seenProducts: {}
      };
    }

    artistStockFromLiquid[artist].totalProducts += 1;
    artistStockFromLiquid[artist].seenProducts[mapping.productId] = true;

    if (isAvailable) {
      artistStockFromLiquid[artist].hasStock = true;
    }
  }

  log('Metaobject stock rule: product_status active + inventory_quantity > 0 + available_for_sale true');
  log('Metaobject product mappings', metaobjectProductMap);
  log('Metaobject stock artists (active only)', metaobjectStockArtists);

  fetchAllProducts()
    .then(function (result) {
      var products = result.products || [];
      log('Collection API products loaded', products.length, '| pages:', result.pagesLoaded || 0);

      var artistStock = {};

      for (var artistKey in artistStockFromLiquid) {
        if (artistStockFromLiquid.hasOwnProperty(artistKey)) {
          artistStock[artistKey] = {
            hasStock: artistStockFromLiquid[artistKey].hasStock,
            totalProducts: artistStockFromLiquid[artistKey].totalProducts,
            seenProducts: artistStockFromLiquid[artistKey].seenProducts
          };
        }
      }

      for (var p = 0; p < products.length; p++) {
        var product = products[p];
        var productId = String(product.id);

        for (var artistName in artistStock) {
          if (!artistStock.hasOwnProperty(artistName)) continue;
          if (!artistStock[artistName].seenProducts[productId]) continue;
          if (!artistStock[artistName].hasStock && productIsAvailable(product)) {
            artistStock[artistName].hasStock = true;
            log('Collection API in-stock | artist:', artistName, '| product id:', productId);
          }
        }
      }

      for (var m = 0; m < metaobjectStockArtists.length; m++) {
        var metaArtist = metaobjectStockArtists[m];
        if (!metaArtist) continue;
        if (!artistStock[metaArtist]) {
          artistStock[metaArtist] = {
            hasStock: true,
            totalProducts: 0,
            seenProducts: {}
          };
          log('Metaobject-only stock | artist:', metaArtist);
        } else if (!artistStock[metaArtist].hasStock) {
          artistStock[metaArtist].hasStock = true;
          log('Metaobject stock applied | artist:', metaArtist);
        }
      }

      var artistItems = root.querySelectorAll('[data-artist-name]');
      var debugRows = [];
      var artistsWithStock = 0;
      var artistsWithoutStock = 0;

      for (var j = 0; j < artistItems.length; j++) {
        var item = artistItems[j];
        var name = item.getAttribute('data-artist-name');
        if (!name) continue;

        var stockInfo = artistStock[name];
        var hasMetaobjectStock = metaobjectStockArtists.indexOf(name) >= 0;
        var hasCollectionStock = !!(stockInfo && stockInfo.hasStock);
        var hasStock = hasCollectionStock || hasMetaobjectStock;
        var reason = getStockReason(hasCollectionStock, hasMetaobjectStock);
        var metaobjectEntries = metaobjectProductMap.filter(function (row) {
          return row.artist === name;
        });

        console.log(
          '[Shop by Artist] artist debug |',
          name,
          '| bold:', hasStock ? 'YES' : 'NO',
          '| reason:', reason,
          '| collection stock:', hasCollectionStock ? 'YES' : 'NO',
          '| metaobject stock (active):', hasMetaobjectStock ? 'YES' : 'NO',
          '| collection products:', stockInfo ? stockInfo.totalProducts : 0,
          '| metaobject entries:', metaobjectEntries
        );

        debugRows.push({
          artist: name,
          bold: hasStock ? 'YES' : 'NO',
          stockReason: reason,
          collectionStock: hasCollectionStock ? 'YES' : 'NO',
          metaobjectStock: hasMetaobjectStock ? 'YES' : 'NO',
          collectionProductCount: stockInfo ? stockInfo.totalProducts : 0,
          metaobjectEntries: metaobjectEntries
        });

        if (hasStock) {
          applyStockState(item, true);
          artistsWithStock++;
        } else {
          applyStockState(item, false);
          artistsWithoutStock++;
        }
      }

      window.__shopByArtistDebug = {
        collection: collectionHandle,
        metaobjectProductMap: metaobjectProductMap,
        metaobjectStockArtists: metaobjectStockArtists,
        artists: debugRows
      };

      log('Apply complete | bold:', artistsWithStock, '| light:', artistsWithoutStock);
      console.log('[Shop by Artist] Summary table — filter bold:NO for out-of-stock artists');
      console.table(debugRows);
    })
    .catch(function (err) {
      log('Apply error', err);
    });
})();
